import { z } from 'zod'
import { clientObject } from '~/packages/general/client/clientObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const veterinaryExamObject = z.object({
  id: z.string().uuid(),
  type: z.string(),
  name: z.string(),
  clientId: clientObject.shape.id,
  observations: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const propertyMap = {
  id: sql`veterinary_exam.id`,
  type: sql`veterinary_exam.type`,
  name: sql`veterinary_exam.name`,
  observations: sql`veterinary_exam.observations`,
  sourceFilter: sql`veterinary_exam.source_filter`,
  clientId: sql`veterinary_exam.client_id`,
  insertUserId: sql`veterinary_exam.insert_user_id`,
  editUserId: sql`veterinary_exam.edit_user_id`,
  createdAt: sql`veterinary_exam.created_at`,
  updatedAt: sql`veterinary_exam.updated_at`,
  deletedAt: sql`veterinary_exam.deleted_at`,
}

export type VeterinaryExamType = z.infer<typeof veterinaryExamObject>
